import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

export type HeaderButton = {
  icon: ReactNode;
  name?: string;
  onClick: () => void;
  disabled?: boolean;
};

type CommonState = {
  openSideBar: boolean;
  buttons: HeaderButton[];
  headerTitle: string;
};

const initialState: CommonState = {
  openSideBar: true,
  buttons: [],
  headerTitle: '',
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    openSideBar: (state) => {
      state.openSideBar = true;
    },
    hideSideBar: (state) => {
      state.openSideBar = false;
    },
    setSpeedDialButtonComponent: (state, action: PayloadAction<HeaderButton[]>) => {
      state.buttons = action.payload;
    },
    removeSpeedDialButtonContent: (state) => {
      state.buttons = [];
    },
    setHeaderTitle: (state, action: PayloadAction<string>) => {
      state.headerTitle = action.payload;
    },
    removeHeaderTitle: (state) => {
      state.headerTitle = '';
    },
  },
});

export const layoutAction = layoutSlice.actions;
export const layoutReducer = layoutSlice.reducer;
